<h1 mat-dialog-title>
  {{ data.hasPriorConvention ? 'Update Data Convention' : 'Create Data Convention' }}
</h1>
<mat-dialog-content class="dialog-body">
  <section class="convention-section">
    <app-data-convention-update
      [dataConvention]="editableConvention"
      (dataConventionChange)="onDataConventionChange($event)"
    ></app-data-convention-update>
  </section>
  @if (showReasonPicker) {
    <section class="reason-section">
      <h2 class="reason-title">Reason for change</h2>
      <mat-form-field appearance="outline" class="reason-field">
        <mat-label>Reason</mat-label>
        <mat-select [formControl]="reasonControl" required>
          @for (reason of selectableReasons; track reason) {
            <mat-option [value]="reason">{{ reason }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </section>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    class="save"
    [disabled]="!canSave"
    (click)="save()"
  >
    Save
  </button>
</mat-dialog-actions>
